import request from '@/utils/request';

export function ApiChangePassword(data){
  return request({
    method: 'post',
    url: '/fenydata-java-console/api/0/v1/user/updatePassword',
    data,
  });
}
